module.exports = __webpack_public_path__ + "voip.png?286bad484efcb729d39095ed9786c5d1";